import { Injectable } from '@angular/core';
import { APIService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ProjectService {
  constructor(
    private apiService: APIService
  ) {}

  /**
   * Service for get a specific project
   *
   * @param {Object} urlParams
   */
  get(urlParams: Object) {
    return this.apiService
      .post('/srv/project/getproject', urlParams);
  }

  /**
   * Service for list all projects
   *
   * @param {Object} urlParams
   */
  getAll(urlParams: Object) {
    return this.apiService
      .post('/srv/project/listprojects', urlParams);
  }

  /**
   * Service for add a new project
   *
   * @param {Object} urlParams
   */
  add(urlParams: Object) {
    return this.apiService
      .post('/srv/project/addproject', urlParams);
  }

  /**
   * Service for delete a specific project
   *
   * @param {Object} urlParams
   */
  delete(urlParams: Object) {
    return this.apiService
      .post('/srv/project/delproject', urlParams);
  }

  /**
   * Service for update a specific project
   *
   * @param {Object} urlParams
   */
  update(urlParams: Object) {
    return this.apiService
      .post('/srv/project/updateproject', urlParams);
  }

  /**
   * Service for select project or clear seleted project
   *
   * @param {Object} urlParams
   */
  select(urlParams?: Object) {
    return this.apiService
      .post('/srv/project/selectproject', urlParams);
  }
}
